'use strict';

var toastr = require('toastr');
var RuleNavigationService = function RuleNavigationService($state, strategyConstants, restangular, transitionSearchCriteriaService) {
  var rulesSearchAPI = restangular.all('rules');
  function removeIdPrefix(technicalId) {
    return technicalId.substring(technicalId.indexOf('_') + 1, technicalId.length);
  }
  function getRuleCreatedBy(technicalId) {
    return rulesSearchAPI.get('?filter=technicalId==' + technicalId).then(function (response) {
      if (!response.detailedRules || response.detailedRules.length === 0) {
        toastr.error('Cannot find the rule you are trying to navigate to. It may have been deleted.');
        return;
      }
      return response.detailedRules[0].createdBy;
    });
  }
  function navigateToRules(technicalId) {
    technicalId = removeIdPrefix(technicalId);
    getRuleCreatedBy(technicalId).then(function (ruleCreatedBy) {
      if (!ruleCreatedBy) {
        return;
      }
      var transitionData = {
        rulesIds: [technicalId],
        searchCriteria: transitionSearchCriteriaService.drawerToRules([ruleCreatedBy]),
        panel: strategyConstants.PANEL_TYPE.OPTIMIZATION
      };
      $state.go('app.rules', {
        transitionData: transitionData
      });
    });
  }
  return {
    navigateToRules: navigateToRules
  };
};
RuleNavigationService.$inject = ['$state', 'StrategyConstants', 'Restangular', 'TransitionSearchCriteriaService'];
module.exports = RuleNavigationService;